export default {
  name: "Nombre de la Tarea",
  buttons: {
    done: "CAMBIAR A COMPLETADA",
    backbtn: "Atrás",
    delete: "Eliminar",
    update: "Actualizar"
  },
  messages: {
    notification: "La alarma le notificará",
    frequency: "Debe ser reemplazada cada",
    before: "antes",
    gotoProfile: "Ir al perfil de la inspección",
    deleteTask:
      "Una vez elimanada, no podrá recuperarla. Por favor asegurese de esta acción.",
    updateTask:
      "Una vez actualizada, no podrá recuperarla. Por favor asegurese de esta acción."
  },
  labels: {
    tag: "Tag del Activo",
    global: "Tarea Global",
    recurrent: "Periódica",
    onetime: "Única",
    maintenance: "Mantenimiento",
    repair: "Reparación",
    reliability: "Confiabilidad",
    done: "COMPLETADA",
    description: "Descripción",
    createdOn: "Tarea Creada",
    frequency: "Frecuencia",
    due: "Vencimiento",
    notification: "Notificación",
    danger: "Zona de Peligro",
    deleteTask: "Eliminar esta tarea",
    updateTask: "Actualizar el contenido de esta tarea"
  }
};
